import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]

  toggle(event) {
    const trigger = event.currentTarget
    const stepId = trigger.dataset.stepId
    const panel = this.panelTargets.find(p => p.dataset.stepId === stepId)
    if (!panel) return

    panel.hidden = !panel.hidden
    const isExpanded = !panel.hidden
    trigger.setAttribute("aria-expanded", isExpanded)

    const chevron = trigger.querySelector("[data-accordion-chevron]")
    if (chevron) {
      chevron.style.transform = isExpanded ? "rotate(180deg)" : ""
    }
  }
}
